<template>
	<div class="tips">温馨提示：<b>您访问的是香港地区网站，投资有风险，入市需谨慎</b></div>
</template>

<script>
export default {
    name: 'warn',
    data () {
	    return {
	        
	    }
    },
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.tips{font-size:.24rem ;padding:.15rem 0 0.15rem .3rem;background:#fff;box-shadow: 0 0 4px rgba(0,0,0,.2);}
	.tips b{font-size:.24rem;color:red;}
</style>



// WEBPACK FOOTER //
// src/components/header/components/Tip.vue